import { show, clear } from './methods.js';

var Toast = {
  show: show,
  clear: clear
};

export { Toast as default };
